const collectData = {
  CollectDataHeader: 'Voice data contribution',
  Send: 'Send',
  Skip: 'Skip',
  CollectDataInstruction: 'Instructions',
  CollectDataRecord: 'Click the Microphone icon to start recording (able to retry many time)',
  CollectDataScript: 'Read out loud the script displayed in the blue box',
  CollectDataSkip: 'Click "Skip" button to get another script',
  CollectDataSend: 'Click "Send" button to send the record',
  CollectDataAcknowledgement: 'We really appreciate your contribution ❤',
  CollectDataCommitment: 'We assure that all data collected will be used for researching purposes only',
}

export default collectData;
